export const isHumanNote = (note) =>
  Boolean(note) &&
  !note.startsWith('Status changed to') &&
  !note.startsWith('Updated from shipment') &&
  note !== 'Order created';
